import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import LayeredModules from './components/LayeredModules';
import Menu from './components/Menu';
import VacancyComponent from './components/VacancyComponent';

export class Alfred {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Alfred.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));

		new Menu();
		new LayeredModules();

		document.querySelectorAll('[data-vacancies]').forEach((el) => new VacancyComponent(el));

		(function ($) {
			jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
				if (formId == 3) {
					window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 'event': 'formSubmission' });
				}
			});
		})(jQuery);
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();